import React from "react";
import "./moreaboutme.css";
import me2 from "../../assest/me2.jpg";
import { useSelector } from "react-redux";

const MoreAboutMe = () => {
  const { portfolioData, loading } = useSelector((state) => state.portfolio);
  return (
    <div className="main_section">
      <p className="about_me__heading">About Me</p>
      <div className="more_about_me_main">
        <img src={me2} alt="my self" className="me_second" />
        <div className="more_about__me">
          <p>
          {
              loading? "Loading...." : portfolioData?.[0]["more_about_me"]
            }
          </p>
        </div>
      </div>
    </div>
  );
};

export default MoreAboutMe;
